import React from 'react';

import { useIntl } from 'react-intl';

import { BarToolTip } from '../BarToolTip';

export function Amazon() {
  const { messages } = useIntl();

  return (
    <BarToolTip title={messages.locales.headers.aa}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.41666 15.8334C3.3456 15.8334 1.66666 14.1544 1.66666 12.0834C1.66666 10.1304 3.15959 8.5261 5.06645 8.34949C5.45651 5.9768 7.51687 4.16669 10 4.16669C12.4831 4.16669 14.5435 5.9768 14.9335 8.34949C16.8404 8.5261 18.3333 10.1304 18.3333 12.0834C18.3333 14.1544 16.6544 15.8334 14.5833 15.8334C10.9251 15.8334 8.61941 15.8334 5.41666 15.8334Z"
          stroke="white"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </BarToolTip>
  );
}
